import {
  FaTree,
  FaHome,
  FaBuilding,
  FaLeaf,
  FaWarehouse,
  FaStore,
  FaUmbrellaBeach,
  FaMapMarkedAlt,
  FaThLarge,
} from "react-icons/fa";

export const categories = [
  { id: "campos", name: "Campos", icon: <FaTree />, path: "/campos" },
  { id: "casas", name: "Casas", icon: <FaHome />, path: "/casas" },
  { id: "departamentos", name: "Departamentos", icon: <FaBuilding />, path: "/departamentos" },
  { id: "forestaciones", name: "Forestaciones", icon: <FaLeaf />, path: "/forestaciones" },
  { id: "galpones", name: "Galpones", icon: <FaWarehouse />, path: "/galpones" },
  { id: "locales", name: "Locales comerciales y oficinas", icon: <FaStore />, path: "/locales" },
  { id: "quintas", name: "Quintas", icon: <FaUmbrellaBeach />, path: "/quintas" },
  { id: "terrenos", name: "Terrenos", icon: <FaMapMarkedAlt />, path: "/terrenos" },
  { id: "otras", name: "Otras Propiedades", icon: <FaThLarge />, path: "/otraspropiedades" },
];
